import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    UpgradeHelper, JourneyImportAndExportHelper, EJourneyToolSearchType,AdminToolHelper
} from '../../../helpers';

import { NO_VALUE_OPERATORS } from '../../../constants';
import { Checkbox, Button, Pivot, PivotItem, PivotLinkSize, IDropdownOption, ButtonType } from 'office-ui-fabric-react';
import store from '../../../store/store';
import { getJourneysByTerm } from '../../../helpers/io';
import { Promise } from 'es6-promise';
import { Search } from '../../common/search';
import { connect } from 'react-redux';
import types from '../../../store/types';
import { BulkImport,FetchXml,AddAllJourneys,UpgradeJourneySearch,ZipList,AdminToolList} from '../../admintool/panels';
import { ProcessUpgradePage } from '../../admintool/screens/processupgradepage';

interface IProps {
    adminToolState: any;
    searchState: any;
}
export class JourneyExportScreen extends React.Component<IProps, any> {
    componentDidMount() {
    }
    onSelectUpgradeToolMode(mode: string) {
        AdminToolHelper.SetPageMode(mode);
    }

    getButtonCss(mode): string {
        return this.props.adminToolState.pageMode == mode ? "active" : "";
    }
    render() {
        if (this.props.adminToolState.isUpgradingScreen) {
            return (<div>
                <ProcessUpgradePage enableCancelButton={false} showStatus={false} adminToolState={this.props.adminToolState} />
                <ZipList adminToolState={this.props.adminToolState} panelName="exportscreen_zipimport" isDisplayed={true} />
            </div>);
        }
        else {
            let textBoxValue: string = "";
            return (<div>
                <h2>Export tool</h2>
                <div className="admintool-advancedtools">
                    <AddAllJourneys journeyToolSearchType={EJourneyToolSearchType.Upgraded} panelName={"exportscreen_alljourneys"} adminToolState={this.props.adminToolState} /> 
                    <UpgradeJourneySearch journeyToolSearchType={EJourneyToolSearchType.Upgraded} adminToolState={this.props.adminToolState} searchState={this.props.searchState} panelName={"exportscreen_search"} isDisplayed={false} />
                    <BulkImport panelTitle={"Journey guids"} adminToolState={this.props.adminToolState} panelName={"exportscreen_bulkimport"} isDisplayed={false} />
                    <FetchXml journeyToolSearchType={EJourneyToolSearchType.Upgraded} adminToolState={this.props.adminToolState} panelName={"exportscreen_fetchxml"} isDisplayed={false} />
                </div>
                <AdminToolList panelTitle={"Journeys to export"} panelName={"exportscreen_AdminToolList"} adminToolState={this.props.adminToolState} enableRemoveButtons={true} showStatus={false} />
                <div className="upgradesettings">
                    <div className="upgradesettinglist">
                        <label>Show Verbose Output:</label>
                        <Checkbox name="advancedLogging" default={false}
                            onChange={(e, isChecked: boolean) => {
                                AdminToolHelper.SetAdminToolSetting(isChecked);
                            }}
                        />
                        <br/>
                        <label>Include Related Service Types:</label>
                        <Checkbox name="relatedservicetypes" checked default={true}/>
                    </div>
                    <Button
                        icon="Accept"
                        buttonType={ButtonType.primary}
                        onClick={() => {
                            let relatedServiceTypesValue:boolean = (document.getElementsByName("relatedservicetypes")[0] as HTMLInputElement).checked;
                            JourneyImportAndExportHelper.StartUpExportProcess(this.props.adminToolState.processList, 800,relatedServiceTypesValue)
                        }}>
                             Start Exporting Journeys
                        </Button>
                </div>
            </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./source/ts/components/admintool/screens/journeyexportscreen.tsx